import DSBox from "views/system-design/DSBox";
import DSCard from "views/system-design/DSCard";
import DSCardContent from "views/system-design/DSCardContent";
import DSTypography from "views/system-design/DSTypography";
import sectionCardSx from "views/system-design/sectionCardSx";

/** A small label-over-value card; `hint` is a quieter line under the value. */
const RetailerKpiCard = ({
  label,
  value,
  hint,
}: {
  label: string;
  value: string | number;
  hint?: string;
}) => (
  <DSCard sx={sectionCardSx}>
    <DSCardContent>
      <DSBox sx={{ typography: "body2", color: "text.secondary", mb: 0.5 }}>
        {label}
      </DSBox>
      <DSBox sx={{ typography: "h6", fontFamily: "Gilroy-Bold" }}>
        {value}
      </DSBox>
      {hint && (
        <DSTypography
          variant="caption"
          sx={{ color: "text.secondary", display: "block", mt: 0.5 }}
        >
          {hint}
        </DSTypography>
      )}
    </DSCardContent>
  </DSCard>
);

export default RetailerKpiCard;
